"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var React = _interopRequireWildcard(require("react"));
require("../../common/style.scss");
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
var _tpmProductIntl = require("@tencent/tpm-product-intl");
var _reportUtil = require("../../utils/reportUtil");
var _componentUtils = require("../../common/componentUtils");
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
/**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */

const formatAdvantageCommon = (properties, options = {}) => {
  const _ref = properties || {},
    _ref$porintId = _ref.porintId,
    porintId = _ref$porintId === void 0 ? '' : _ref$porintId,
    _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items;
  const handledList = items === null || items === void 0 ? void 0 : items.map((activityItem, index) => {
    const _ref2 = activityItem || {},
      title = _ref2.title,
      desc = _ref2.desc,
      img = _ref2.img,
      mobileImg = _ref2.mobileImg,
      btnText = _ref2.btnText,
      btnHref = _ref2.btnHref,
      _ref2$btnList = _ref2.btnList,
      btnList = _ref2$btnList === void 0 ? [] : _ref2$btnList;
    let btns = [];
    if (btnText && btnHref && btnList.length === 0) {
      btns = [{
        btnText,
        btnHref
      }];
    } else {
      btns = btnList;
    }
    const handleBtns = () => {
      return btns.map((item, key) => {
        const btnText = item.btnText,
          btnHref = item.btnHref;
        const btnExtendProps = {
          'report-event': 'click_TransferModule_button',
          'report-ext1': index,
          'report-ext2': key,
          'report-ext3': btnText || '',
          target: '_blank'
        };
        if (key === 0) {
          return /*#__PURE__*/React.createElement(_tpmProductIntl.Button, Object.assign({
            type: 'solid-white',
            icon: true,
            align: 'center',
            href: btnHref
          }, btnExtendProps), btnText);
        }
        return /*#__PURE__*/React.createElement(_tpmProductIntl.Button, Object.assign({
          type: 'weak-white',
          icon: true,
          align: 'center',
          href: btnHref
        }, btnExtendProps), btnText);
      });
    };
    return {
      title,
      desc,
      img: (0, _componentUtils.doComponentsUploadEvent)(img || '').url,
      mobileImg: (0, _componentUtils.doComponentsUploadEvent)(mobileImg || '').url,
      btns: btnText && btnHref || btnList.length > 0 ? handleBtns() : null
    };
  });
  const list = handledList.length > 2 ? handledList.slice(0, 2) : handledList;
  return {
    porintId,
    items: list
  };
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  if (Object.keys(data).length > 1) {
    const heroData = formatAdvantageCommon(data, {
      domains
    });
    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: (heroData === null || heroData === void 0 ? void 0 : heroData.porintId) || '',
      className: "gems-materials-qci__newUI-transferModule"
    }, (0, _reportUtil.reportShow)(['show_newUI_TransferModule', componentKey, ''])), /*#__PURE__*/React.createElement(_tpmProductIntl.ActionPanel, heroData));
  } else {
    return /*#__PURE__*/React.createElement("div", null);
  }
}